export const isUndefined = (value: unknown): value is undefined =>
    value === undefined;